package org.zq.astrock_ai.ui.research.gushi

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/** 研究台宽度断点 */
object WorkbenchBreakpoints {
    val PhoneMax = 600.dp
    val CompactMax = 900.dp
    val WideMin = 1100.dp
}

fun isPhoneWidth(maxWidth: Dp): Boolean = maxWidth < WorkbenchBreakpoints.PhoneMax

fun isCompactWidth(maxWidth: Dp): Boolean = maxWidth < WorkbenchBreakpoints.WideMin

/**
 * 弹窗宽度：占屏约 94%，且不超过 [preferred]。
 * 避免手机上固定 420~480.dp 超出屏幕。
 */
fun Modifier.adaptiveDialogWidth(preferred: Dp = 440.dp): Modifier =
    this
        .fillMaxWidth(0.94f)
        .widthIn(max = preferred)
